var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "profile-field__title",
          class: {
            "profile-field__title--required": _vm.field.required,
          },
        },
        [_vm._v(" Последние места работы ")]
      ),
      _c(
        "div",
        _vm._l(_vm.localValue, function (job, i) {
          return _c("c-item", {
            key: job.unique,
            attrs: {
              field: _vm.field,
              value: job,
              preview: _vm.preview,
              editable: _vm.editable,
              error: _vm.error && _vm.error.items[i],
              "can-remove": true,
              options: _vm.options,
            },
            on: {
              remove: function ($event) {
                return _vm.removeJob(job)
              },
            },
          })
        }),
        1
      ),
      _c(
        "div",
        { staticClass: "add-job" },
        [
          _c("c-button", {
            attrs: {
              icon: { icon: "plus", color: "primary" },
              label: "Добавить место работы",
              disabled: _vm.preview || !_vm.editable || _vm.hasEmpty,
              size: "small",
            },
            on: { click: _vm.addJob },
          }),
        ],
        1
      ),
      _vm.error && _vm.error.common
        ? _c("error-feedback", {
            attrs: { text: _vm.error && _vm.error.common },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }